import { type QueryClient } from "@tanstack/react-query";
import { type Api } from "api-client";
import { assert } from "utils";

import { organizationsQueryOptions } from "src/queries/organizations";
import { type IsomorphicRequestData } from "src/types";

import { loaderHandler, type LoaderReturn } from "./loaderHandler";

interface OrgLoaderHandlerInput {
  queryClient: QueryClient;
  slug: string;
}

type Organization = Api.ListOrganizations.Output.Organization;

type OrgLoaderData = IsomorphicRequestData & {
  organization: Organization;
};

export function orgLoaderHandler<T extends LoaderReturn>(
  input: OrgLoaderHandlerInput,
  cb: (data: OrgLoaderData) => T | Promise<T>,
): Promise<T> {
  return loaderHandler(async (data) => {
    const organizations = await input.queryClient.query({
      ...organizationsQueryOptions(),
      staleTime: "static",
    });
    const organization = organizations.find((item) => {
      return item.slug === input.slug;
    });
    assert(organization, "Organization not found");

    return await cb({ ...data, organization });
  });
}
